import querystring, { type ParsedUrlQueryInput } from 'querystring';

import { ServiceNames } from './serviceNames';

interface FetchrConfig {
    apiUrl: string;
}

export const hotelOfferService = {
    resource: ServiceNames.HOTEL_OFFER_SERVICE,

    read: async (
        _req: unknown,
        _resource: unknown,
        params: ParsedUrlQueryInput,
        config: FetchrConfig,
        callback: (error: unknown, response: unknown) => unknown,
    ): Promise<void> => {
        let { apiUrl } = config;
        if (apiUrl === undefined) {
            // @ts-expect-error req.path is not defined in NextApiRequest
            apiUrl = _req.apiUrl;
        }
        const { hotelId, ...rest } = params;

        let url = `${apiUrl}/hotel/offers/${encodeURIComponent(hotelId as string)}`;
        if (rest) {
            url = `${url}?${querystring.stringify(rest)}`;
        }

        try {
            const response = await fetch(url);
            const json = await response.json();

            callback(null, json);
        } catch (e) {
            callback(e, { reason: `failed fetching from ${url}` });
        }
    },
};
